import React, { useState } from "react";
import { CaretDownIcon } from "@phosphor-icons/react";

const FAQ = [
  {
    q: "Is Bidorah safe to buy from?",
    a: "Yes. Every seller is ID-verified (US government photo ID + face match), every payment is held in Stripe escrow until delivery, and our anti-shill bidding detector flags fake bids in real time. If anything goes wrong, you're covered.",
  },
  {
    q: "How do auctions and bids work?",
    a: "Click into a live show, hit BID to outbid by the minimum increment (or type your own amount), and watch the counter update live. The highest bidder when the seller closes the lot wins. Payment is charged automatically to your saved card.",
  },
  {
    q: "What's the difference between retail and wholesale?",
    a: "Retail accounts are for personal collectors buying single items. Wholesale accounts are for verified businesses buying in bulk to resell. Wholesale buyers must submit a resale permit, TIN, and business entity — wholesale and retail inventory never mix.",
  },
  {
    q: "When do sellers get paid?",
    a: "After 10 completed sales, all payouts are instant — funds hit your bank within minutes of buyer delivery confirmation. Before that, payouts are held in a short review window and released once the buyer confirms delivery.",
  },
  {
    q: "What's Bidorah's commission?",
    a: "5% flat on retail, 4.5% on wholesale. No hidden fees, no seller tiers. Founder Sellers pay 0% commission for their first 14 days (clock starts the day your application is approved) and keep Founder badging permanently.",
  },
  {
    q: "Can I return an item?",
    a: "Fixed-price listings carry a 7-day return window — if the item doesn't match the listing, we refund in full. Auction wins are final, so inspect the stream and ask questions in chat before you bid.",
  },
  {
    q: "Is there a mobile app?",
    a: "Yes — the Android app is launching shortly on Google Play. iOS is on the roadmap. In the meantime, open bidorah.com on your phone and tap 'Add to Home Screen' for a near-native app experience with push notifications.",
  },
];

export default function HomeFAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      className="bg-zinc-50 border-b border-zinc-200"
      data-testid="home-faq"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        <p className="text-sm font-semibold text-[#1D78AB] mb-3 text-center">
          Frequently asked
        </p>
        <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter text-center leading-tight">
          Everything you want to ask before bidding.
        </h2>

        <div className="mt-12 space-y-3">
          {FAQ.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className={`rounded-2xl border bg-white transition-colors ${
                  open
                    ? "border-[#1D78AB]"
                    : "border-zinc-200 hover:border-zinc-300"
                }`}
                data-testid={`faq-item-${idx}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  data-testid={`faq-toggle-${idx}`}
                >
                  <span className="font-display font-bold text-zinc-900 text-lg">
                    {item.q}
                  </span>
                  <CaretDownIcon
                    size={18}
                    weight="bold"
                    className={`text-zinc-400 flex-shrink-0 transition-transform ${
                      open ? "rotate-180 text-[#1D78AB]" : ""
                    }`}
                  />
                </button>
                {open && (
                  <div
                    className="px-5 pb-5 text-zinc-600 text-sm leading-relaxed"
                    data-testid={`faq-answer-${idx}`}
                  >
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
